import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { IoChevronBackOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { fetchPrograms } from "../../redux/programs/action";
import MainProgram from "./MainProgram";
import PGProgram from "./PGProgram";
import UGProgram from "./UGProgram";
import CoursesUG from "./CoursesUG";
import CoursesPG from "./CoursesPG";
import { BiLinkExternal } from "react-icons/bi";

const MobileExplorePrograms = ({ toggleClose }) => {
  const [isUGProgramVisible, setIsUGProgramVisible] = useState(false);
  const [isPGProgramVisible, setIsPGProgramVisible] = useState(false);
  const [selectedUGProgramIndex, setSelectedUGProgramIndex] = useState(null);
  const [selectedPGProgramIndex, setSelectedPGProgramIndex] = useState(null);
  const [openSectionId, setOpenSectionId] = useState(null);
  const [ugProgramRecords, setUgProgramRecords] = useState([]);
  const [pgProgramRecords, setPgProgramRecords] = useState([]);
  const [allProgramRecords, setAllProgramRecords] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const routeToProgram = (id) => {
    navigate(`program/${id}`);
    toggleClose();
  };

  const fetchData = async () => {
    try {
      const result = await dispatch(fetchPrograms());
      if (Array.isArray(result)) {
        const ugProgramsArray = result.filter(
          (program) => program.level === "Graduation"
        );
        const pgProgramsArray = result.filter(
          (program) => program.level === "Post Graduation"
        );

        // Organize programs
        const organizedUGPrograms = organizePrograms(ugProgramsArray);
        const organizedPGPrograms = organizePrograms(pgProgramsArray);

        setUgProgramRecords(organizedUGPrograms);
        setPgProgramRecords(organizedPGPrograms);

        // Combine UG and PG programs
        setAllProgramRecords([...organizedUGPrograms, ...organizedPGPrograms]);
        console.log("allprogram records", organizedUGPrograms);
      } else {
        console.error("Unexpected response format:", result);
      }
    } catch (error) {
      console.error("Error fetching programs:", error);
    }
  };

  const organizePrograms = (programArray) => {
    let organizedArray = [];
    programArray.forEach((record) => {
      const programName = record.programName;
      const existingProgramIndex = organizedArray.findIndex(
        (program) => program.programName === programName
      );

      if (existingProgramIndex === -1) {
        organizedArray.push({
          id: organizedArray.length,
          programName,
          programId: record.programId,
          universityName: record.universityName,
          count: 1,
          records: [record],
        });
      } else {
        organizedArray[existingProgramIndex].records.push(record);
        organizedArray[existingProgramIndex].count++;
      }
    });
    return organizedArray;
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onUGClick = () => {
    setIsUGProgramVisible(!isUGProgramVisible);
    setIsPGProgramVisible(false);
  };

  const onPGClick = () => {
    setIsPGProgramVisible(!isPGProgramVisible);
    setIsUGProgramVisible(false);
  };

  const toggleSection = (id) => {
    setOpenSectionId((prevId) => (prevId === id ? null : id)); // Toggle or close
  };

  // Function to handle UG program click
  const onUGProgramClick = (id, index) => {
    setSelectedPGProgramIndex(null); // Reset selected PG program index
    setIsPGProgramVisible(false); // Set visibility to false for PG program
    setSelectedUGProgramIndex(index); // Set selected UG program index
  };

  // Function to handle PG program click
  const onPGProgramClick = (id, index) => {
    setSelectedUGProgramIndex(null); // Reset selected UG program index
    setIsUGProgramVisible(false); // Set visibility to false for UG program
    setSelectedPGProgramIndex(index); // Set selected PG program index
  };

  const resetIndexes = () => {
    setSelectedPGProgramIndex(null); // Set selected PG program index
    setSelectedUGProgramIndex(null); // Set selected UG program index
  };

  // function to handle
   const handleCourseClick = () => {
    toggleClose();
    
   };
   
  return (
    <div className="mx-auto h-[100vh] overflow-auto px-4 sm:px-6 text-left">
      {selectedPGProgramIndex !== null || selectedUGProgramIndex !== null ? (
        <div
          className="w-full my-4 flex items-center cursor-pointer"
          onClick={resetIndexes}
        >
          <IoChevronBackOutline className="mr-2 text-primary-color text-xl md:text-2xl" />
          <p className="text-primary-color text-lg md:text-xl font-medium md:font-semibold">
            Back
          </p>
        </div>
      ) : null}

      {selectedPGProgramIndex === null && selectedUGProgramIndex === null ? (
        <>
          <div className="w-full space-y-4 my-4">
            <p className="text-primary-color text-xl font-bold flex items-center gap-2">
              Programs
              <a
                href="/ExploreOurCourses"
                className="md:hidden text-gray-700 hover:text-[#04236B] transition-colors duration-200"
              >
                <BiLinkExternal className="text-xl" />
              </a>
            </p>
          </div>

          <div className="w-full space-y-6">
            <div className="text-slate-950 flex flex-col items-start h-[395px] overflow-y-auto scrollbar-hide w-full">
              {/* UG Program */}
              <div className="w-full">
                <MainProgram
                  isActive={isUGProgramVisible}
                  onMainProgramClick={onUGClick}
                  className="w-full"
                >
                  <span className="text-lg font-semibold">UG Program</span>
                </MainProgram>
                {/* UG Sub Programs */}
                {isUGProgramVisible && (
                  <div className="w-full mt-2">
                    {ugProgramRecords.map((program, index) => (
                      <div
                        key={index}
                        className={`w-full ${
                          index !== ugProgramRecords.length - 1
                            ? "border-b border-gray-200"
                            : ""
                        }`}
                      >
                        <UGProgram
                          program={program}
                          onClick={() =>
                            onUGProgramClick(
                              program.records[0].programId,
                              index
                            )
                          }
                          isActive={selectedUGProgramIndex === index}
                          className="w-full"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* Border after UG */}
              <div className="border-b border-gray-300 my-3 w-full"></div>
              {/* PG Program */}
              <div className="w-full">
                <MainProgram
                  isActive={isPGProgramVisible}
                  onMainProgramClick={onPGClick}
                  className="w-full"
                >
                  <span className="text-lg font-semibold">PG Program</span>
                </MainProgram>
                {/* PG Sub Programs */}
                {isPGProgramVisible && (
                  <div className="w-full mt-2">
                    {pgProgramRecords.map((program, index) => (
                      <div
                        key={index}
                        className={`w-full ${
                          index !== pgProgramRecords.length - 1
                            ? "border-b border-gray-200"
                            : ""
                        }`}
                      >
                        <PGProgram
                          program={program}
                          onClick={() =>
                            onPGProgramClick(
                              program.records[0].programId,
                              index
                            )
                          }
                          isActive={selectedPGProgramIndex === index}
                          className="w-full"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="w-full space-y-4">
          {/* Courses section for selected programs */}
          <div>
            {selectedUGProgramIndex !== null && (
              <div className="w-full">
                <CoursesUG
                  program={ugProgramRecords[selectedUGProgramIndex]}
                  isMobile={true} onCourseClick={handleCourseClick}
                />
              </div>
            )}
          </div>
          <div>
            {selectedPGProgramIndex !== null && (
              <div className="w-full">
                <CoursesPG
                  program={pgProgramRecords[selectedPGProgramIndex]}
                  isMobile={true} onCourseClick={handleCourseClick}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileExplorePrograms;
